"use client";

import { useEffect, useState } from "react";
import { FEATURED_WORK } from "@/constants/home.constants";

export function useFeaturedWorkCarousel() {
  const [active, setActive] = useState(0);
  const total = FEATURED_WORK.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 4000);
    return () => window.clearInterval(timer);
  }, [total]);

  const prev = () => setActive((p) => (p - 1 + total) % total);
  const next = () => setActive((p) => (p + 1) % total);

  return { active, setActive, prev, next, total };
}
